import React, { useLayoutEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom"
import './work.scss';
import projects from '../../projects'

function Work(props) {
    const navigate = useNavigate();

    useLayoutEffect(() => {
        const cursor = document.querySelector(".cursor")
        const projectImages = document.querySelectorAll(".projects-container .project-img")
        const projectLinks = document.querySelectorAll(".projects-container-2 .projects-wrapper")

        projectImages.forEach((image) => {
            image.addEventListener("mouseover", () => {
                cursor.style.scale = "1"
                cursor.style.display = "block"
            })
            image.addEventListener("mouseout", () => {
                cursor.style.scale = "0"
            })
            image.addEventListener("click", () => {
                cursor.style.scale = "0"
            })
        })

        projectLinks.forEach((link) => {
            link.addEventListener("mouseover", () => {
                cursor.style.scale = "0.8"
                link.style.display = "block"
            })
            link.addEventListener("mouseout", () => {
                cursor.style.scale = "0"
            })
            link.addEventListener("click", () => {
                cursor.style.scale = "0"
            })
        })

        // console.log(projects.slice(0,4))
    })
    //image cursor
    useLayoutEffect(() => {
        const imgCursor = document.querySelector(".img-cursor")
        const projectLinks = document.querySelectorAll(".projects-container-2 .projects-wrapper")
        const imgScroll = document.querySelector(".image-scroll")

        projectLinks.forEach((link) => {
            link.addEventListener("mouseover", () => {
                imgCursor.style.scale = "0.8"
                imgCursor.style.opacity = "1"
            })
            link.addEventListener("mouseout", () => {
                imgCursor.style.scale = "0"
            })
            link.addEventListener("click", () => {
                imgCursor.style.scale = "0"
            })
        })

        const numberOfProjects = projects.length;
        const offset = 100 / numberOfProjects;

        for(let i=0; i<props.display; i++){
            projectLinks[i].addEventListener("mouseover", () => {
                imgScroll.style.transform = "translateY(-" + (i*offset) + "%)"
            })
        }
        
        // projectLinks[0].addEventListener("mouseover", () => {
        //     imgScroll.style.transform = "translateY(-0%)"
        // })
        // projectLinks[1].addEventListener("mouseover", () => {
        //     imgScroll.style.transform = "translateY(-14.2857%)"
        // })
        // projectLinks[2].addEventListener("mouseover", () => {
        //     imgScroll.style.transform = "translateY(-28.571428%)"
        // })
        // projectLinks[3].addEventListener("mouseover", () => {
        //     imgScroll.style.transform = "translateY(-42.8571428%)"
        // })
        // projectLinks[4].addEventListener("mouseover", () => {
        //     imgScroll.style.transform = "translateY(-57.1428571%)"
        // })
        // projectLinks[5].addEventListener("mouseover", () => {
        //     imgScroll.style.transform = "translateY(-71.428571428%)"
        // })
        // projectLinks[6].addEventListener("mouseover", () => {
        //     imgScroll.style.transform = "translateY(-85.714285714%)"
        // })
    })

    

    return (
        <section id='work-section' className='section'>
            <div id='work-section-wrapper'>
                <header className='work-section-header'>
                        <h1 className='select-projects select-projects-h1'>
                            A few
                        </h1>
                        <h1 className='select-projects select-projects-h2'>
                            select
                        </h1>
                        <h1 className='select-projects select-projects-h3'>
                            Projects
                        </h1>
                </header>
                <div className='projects-container'>
                    {projects.slice(0, props.display).map((project, index) => (
                        <div className='project-box' key={ index + 1 }>
                            <h1>0{ index + 1 }-04</h1>
                            <Link  to={`/${project.name}`} state={{ state: project }} className='project-img'>
                                <picture>
                                    <source srcSet={project.sqImgUrl} media="(max-width: 500px)"/>
                                    <img src={project.imgUrl} alt={project.name} loading="lazy"></img>
                                </picture>
                                <Link  to={`/${project.name}`} state={{ state: project }}  className='project-arrow project-bottom-arrow' name={project.name} title={project.name}>
                                    <button name={project.name} title={project.name}>
                                        <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="m.819 50.513 8.307 8.238 38.423-38.454-.059 28.89h11.638V.424H10.47l-.14 11.564h28.983L.819 50.513Zm55.31-47.09v42.764V3.424Z" fill="#ffffff"></path></svg>
                                    </button>
                                </Link>
                            </Link>
                            <div className='project-text'>
                                <h2>{ project.name }</h2>
                                <p>{ project.gist }</p>  
                            </div>
                        </div>
                    ))}
                </div>
                <div className='projects-container-2'>
                    {projects.slice(0, props.display).map((project, index) => (
                        <Link to={`/${project.name}`} state={{ state: project }} className='projects-wrapper' key={ index + 1 }>
                            <div className='project'>
                                <h2>{ project.name }</h2>
                                <p>{ project.type }</p>
                            </div>
                            <span className='project-number'>0{ index + 1 }</span>
                        </Link>
                    ))}
                </div>
                <div className='more-projects-btn'><Link to='/projects'><button>more projects</button></Link></div>
            </div>

        </section>
    )   
}
export default Work;